import { render, staticRenderFns } from "./LianList.vue?vue&type=template&id=3b3bfb98&scoped=true&"
import script from "./LianList.vue?vue&type=script&lang=js&"
export * from "./LianList.vue?vue&type=script&lang=js&"
import style0 from "./LianList.vue?vue&type=style&index=0&id=3b3bfb98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bfb98",
  null
  
)

export default component.exports